import { z } from "zod";
import { map } from "../../lib/functional";
import { safeParse, unionOfLiterals } from "../../lib/zod";
import {
  ControlDefinition,
  serialize
} from "../definition";
import { DefaultControlInstance } from "../instance";
class Definition extends ControlDefinition {
  static type = "makeswift::controls::icon-radio-group";
  static Icon = {
    TextAlignCenter: "TextAlignCenter",
    TextAlignJustify: "TextAlignJustify",
    TextAlignLeft: "TextAlignLeft",
    TextAlignRight: "TextAlignRight",
    Superscript: "Superscript16",
    Subscript: "Subscript16",
    Code: "Code16"
  };
  static schema(item, data, defaultValue) {
    const type = z.literal(Definition.type);
    const value = data;
    const resolvedValue = value;
    const config = z.object({
      options: z.array(
        z.object({
          value: item,
          label: z.string(),
          icon: z.union([
            z.literal(Definition.Icon.Code),
            z.literal(Definition.Icon.Subscript),
            z.literal(Definition.Icon.Superscript),
            z.literal(Definition.Icon.TextAlignCenter),
            z.literal(Definition.Icon.TextAlignJustify),
            z.literal(Definition.Icon.TextAlignLeft),
            z.literal(Definition.Icon.TextAlignRight)
          ])
        })
      ).nonempty(),
      defaultValue,
      label: z.string().optional()
    });
    const definition = z.object({
      type,
      config
    });
    return {
      type,
      data,
      value,
      resolvedValue,
      config,
      definition
    };
  }
  static deserialize(data) {
    if (data.type !== Definition.type) {
      throw new Error(
        `IconRadioGroup: expected type ${Definition.type}, got ${data.type}`
      );
    }
    const { config: configSchema } = Definition.schema(
      z.string(),
      z.string().optional(),
      z.string().optional()
    );
    const def = z.object({
      type: z.literal(Definition.type),
      config: configSchema
    });
    const { config } = def.parse(data);
    return new IconRadioGroupDefinition(config);
  }
  get controlType() {
    return Definition.type;
  }
  get schema() {
    return Definition.schema(
      this.itemSchema,
      this.dataSchema.optional(),
      this.itemSchema.optional()
    );
  }
  get itemSchema() {
    return unionOfLiterals(
      map(this.config.options, ({ value }) => value)
    );
  }
  get dataSchema() {
    const item = this.itemSchema;
    return this.config.defaultValue === void 0 ? item.optional() : item;
  }
  safeParse(data) {
    return safeParse(this.dataSchema, data);
  }
  fromData(data) {
    return this.dataSchema.optional().parse(data);
  }
  toData(value) {
    return value;
  }
  copyData(data, _context) {
    return data;
  }
  resolveValue(data) {
    return {
      name: Definition.type,
      readStable: () => this.fromData(data) ?? this.config.defaultValue,
      subscribe: () => () => {
      },
      triggerResolve: async () => {
      }
    };
  }
  createInstance(sendMessage) {
    return new DefaultControlInstance(sendMessage);
  }
  serialize() {
    return serialize(this.config, {
      type: Definition.type
    });
  }
}
class IconRadioGroupDefinition extends Definition {
}
function unstable_IconRadioGroup(config) {
  return new IconRadioGroupDefinition(config);
}
unstable_IconRadioGroup.Icon = Definition.Icon;
export {
  IconRadioGroupDefinition,
  unstable_IconRadioGroup
};
//# sourceMappingURL=icon-radio-group.js.map